var React = require('react');

function OnlineOnlyIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.81012 14.2175C5.81012 12.181 7.46107 10.53 9.49762 10.53H49.9126C51.9492 10.53 53.6001 12.181 53.6001 14.2175V40.4725C53.6001 42.5091 51.9492 44.16 49.9126 44.16H9.49762C7.46107 44.16 5.81012 42.5091 5.81012 40.4725V14.2175ZM37.6702 27.4579L25.7227 34.3557V20.56L37.6702 27.4579ZM21.4453 46.52C20.6307 46.52 19.9703 47.1804 19.9703 47.995C19.9703 48.8096 20.6307 49.47 21.4454 49.47H37.9654C38.78 49.47 39.4403 48.8096 39.4403 47.995C39.4403 47.1804 38.78 46.52 37.9653 46.52H21.4453Z","fill":"var(--secondary-colour)"}));
}

OnlineOnlyIconInline.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none"};

module.exports = OnlineOnlyIconInline;

OnlineOnlyIconInline.default = OnlineOnlyIconInline;
